import React, { useCallback } from 'react';

import type { Invitees } from '@atlassian/invite-prompt/types';
import { InviteSuccessFlag } from '@atlassian/invite-prompt/invite-success-flag/main';

import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';

const PRODUCT = 'jira-software';

export const useInviteSuccessFlag = (
	flags?: FlagsStateContainer,
): ((invitees: Invitees) => void) => {
	return useCallback(
		(invitees: Invitees) => {
			const dismiss = (id: string | number) => flags?.hideFlag(id);

			flags?.showFlag({
				customComponent: (props) => (
					<InviteSuccessFlag
						{...props}
						id={props.id}
						invitees={invitees}
						product={PRODUCT}
						onDismiss={dismiss}
					/>
				),
			});
		},
		[flags],
	);
};
